/**
 * 送审前条件校验由后端执行；前端仅展示接口返回结果。
 * 列表「未送审」原因：reviewStatus=0 时使用行数据 missingReason（字段级缺失说明）。
 */

/** 列表行：未送审时在审核状态标签下方展示的文案 */
export function getListReviewMissingHint(record) {
  if (!record || record.reviewStatus !== 0) return ''
  return (record.missingReason || '').trim()
}
